import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
import moment from 'moment'
import ConfirmDialogPreset from '@/components/autoImport/ConfirmDialogPreset'

const module = {
  state: {
    defaultDoBrowse: {
      searchInfo: {
        schedule_date: moment().startOf('isoWeek').format('YYYY-MM-DD'),
        student_no: null,
      },
      doBrowseStatus: 'init',

      selectedStudentData: null,
      studentSchedule: {},
      targetCenterNo: null,
    },
    selectedStudentData: null,
    studentSchedule: {},

    targetCenterNo: null,
  },

  getters: {},

  mutations: {},

  actions: {
    init ({ commit, state }, payload) {
      $this.$api.postData({
        data: {
          dropdownData: {
            api: 'T3110LessonReportService.C50101_getDropdownData',
            input: payload,
          }
        }
      }).then((res) => {
        $this.$setState('C20301', {
          dropdownData: res.dropdownData.output
        })
      })
    },
    async C20301_getStudentSchedule({ commit, state, dispatch }, payload) {
      return $this.$api.postData({
        data: {
          C20301_getStudentSchedule: {
            api: 'T3010ScheduleService.C20301_getStudentSchedule',
            input: {
              ...state.searchInfo,
            },
          }
        }
      }).then((res) => {
        $this.$setState('C20301', {
          studentSchedule: res.C20301_getStudentSchedule.output,
          doBrowseStatus: 'loaded',
        })
      })
    },
    async C20301_doAction({ commit, state, dispatch },{
      oldCenterNo,
      newCenterNo,
    }) {
      const centerList = $this.$store.state.Auth.m0110CenterGroup
      console.log('centerList', centerList,{
        oldCenterNo,
        newCenterNo,
      })
      const oldCenter = centerList.find(c => c.value === oldCenterNo)?.label || $this.$t('C20301.C20301Store.sent')
      const newCenter = centerList.find(c => c.value === newCenterNo)?.label || $this.$t('C20301.C20301Store.sent-0')

      const result = await $this.$confirm({
        ...ConfirmDialogPreset.baseConfirm($this),
        text:$this.$t('C20301.C20301Store.oldcenterkaranewcenterheriemasuyoroshiidesuka', [oldCenter, newCenter]),
      })
      if (!result)
        return
      const input = {
        student_no: state.searchInfo.student_no,
        schedule_date: state.searchInfo.schedule_date,
        target_center_no: state.targetCenterNo,
      }
      const output = await $this.$api.postData({
        data: {
          C20301_doAction: {
            api: 'T3010ScheduleService.C20301_doAction',
            input,
          }
        },
        databaseDiff:{
          tables: [
            't3010_schedule',
            't1010_student_basic'
          ]
        }
      })
      $this.$toast.success($this.$t('C20301.C20301Action.belongsUpdated'))
      console.log(output)
      $this.$setState('C20301', {
        ...state.defaultDoBrowse,
      })
    },
    async C20301_doReset({ commit, state }) {
      $this.$setState('C20301', {
        ...state.defaultDoBrowse,
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
